import React from 'react';
import { Filter } from '../FiltersMenu';
import { useFiltersContextHelper } from '../useFiltersContextHelper';
import OperationSelect from '../OperationSelect';
import AddFilterBtn from '../AddFilterBtn';
import { getFixedDateRanges } from '../FixedDateRanges';
import { Box } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import FilterFooter from '../FilterFooter';

import { findFiltersByPath } from '../../../../context/helpers';
import {useIdeaFilters} from "../../../../hooks/useIdeaFilters";

interface DateFilterProps {
  filters?: Filter;
  MenuType: "idea" | "evidence";
  onApplied?: () => void;
  setValue?: (value: any) => void;
  hideOperations?: boolean;
}

const DateFilter: React.FC<DateFilterProps> = ({
  MenuType,
  onApplied,
  setValue,
  hideOperations,
}) => {
  const {
    setOperator,
    rangeDates,
    setRangeDates,
    childFiltersValue,
    selectedParentFilter,
    setActiveFilters,
    setOpenedMenuType,
    setSelectedParentFilter
  } = useFiltersContextHelper();
  const { ideasFiltersConfig } = useIdeaFilters();


  const _selectedParentFilter: string[] = selectedParentFilter?.split('.') || [''];

  const selectedFilter = (_selectedParentFilter && _selectedParentFilter.length === 2)
  //@ts-ignore
    ? ideasFiltersConfig[MenuType][_selectedParentFilter[0]]?.childFilters[_selectedParentFilter[1]]
    : ideasFiltersConfig[MenuType][_selectedParentFilter[0]]

  const selectedHasOperations = selectedFilter?.operations?.length > 0 || false;

  return (
    selectedParentFilter && <>
      {selectedHasOperations && !hideOperations && (
        <OperationSelect
          operations={selectedFilter.operations}
          onChange={(value) => {
            typeof value == 'string' && setRangeDates((pre) => ({
              ...pre,
              [selectedParentFilter]: getFixedDateRanges[value].values,
            }))
            setOperator((prev: any) => ({
              ...prev,
              [selectedParentFilter]: value,
            }));
          }}
        />
      )}
      <Box py="sm">
        <DatePicker
          type='range'
          p={0}
          m={0}
          value={rangeDates?.[selectedParentFilter]}
          onChange={(value: any) => {
            setRangeDates((pre) => ({
              ...pre,
              [selectedParentFilter]: value,
            }))
          }}
          styles={() => ({
            day: {
              "&[data-selected]": {
                backgroundColor: "#5B60E3",
              },
              "&[data-in-range]": {
                backgroundColor: "#5b60e321",
                "&[data-selected]": {
                  backgroundColor: "#5B60E3",
                },
              },
              "&[data-weekend]": {
                color: `#5B60E3`,
                "&[data-selected]": {
                  color: "#FFF",
                },
              },
            },
          })}
        />
      </Box>

      <FilterFooter
        ApplyButton={
          <AddFilterBtn
            BtnText="Apply"
            selectedParentFilter={selectedParentFilter}
            childFiltersValue={childFiltersValue}
            disabled={
              !rangeDates?.[selectedParentFilter] ||
                    !rangeDates?.[selectedParentFilter][0] ||
                    !rangeDates?.[selectedParentFilter][1]
            }
            onClick={() => {
              const parentFilterObj = findFiltersByPath(ideasFiltersConfig, `${MenuType}.${selectedParentFilter}`);
              const filterObj = {
                ...parentFilterObj,
                type: parentFilterObj?.type,
                parent: selectedParentFilter,
                // operator: operator && operator[selectedParentFilter],
                selected: rangeDates?.[selectedParentFilter],
                query: null,
              }

              if (MenuType === 'evidence') {
                if (setValue) {
                  const selected = filterObj?.selected || null;
                  console.log('🔍 [DateFilter] Custom calendar apply - setting value:', {
                    selected,
                    start: selected[0]?.toISOString?.(),
                    end: selected[1]?.toISOString?.(),
                  });
                  setValue({ start: selected[0].toISOString(), end: selected[1].toISOString() });
                } else {
                  setActiveFilters((prevFilters: any) => [
                    filterObj,
                    ...prevFilters.filter(
                      (prevF: any) => prevF.parent !== selectedParentFilter
                    )
                  ]);
                }
              } else {
                setActiveFilters((prevFilters: any) => [
                  filterObj,
                  ...prevFilters.filter(
                    (prevF: any) => prevF.parent !== selectedParentFilter
                  )
                ]);
              }
              setOpenedMenuType(null)
              setSelectedParentFilter(null)
              // resetFilters();
              onApplied?.();
            }}
          />
        }
      />

      
    </>
  );
};

export default DateFilter;
